export const PRINTING_GROUPS: {
  EMBROIDERY_GROUPS: string[];
  SUBLIMATION_GROUPS: string[];
  DEBOSSING_GROUPS: string[];
  LASER_GROUPS: string[];
  CERAMIC_GROUPS: string[];
} = {
  EMBROIDERY_GROUPS: ['E'],
  SUBLIMATION_GROUPS: ['TS', 'TSM', 'TST'],
  DEBOSSING_GROUPS: ['B'],
  LASER_GROUPS: ['RL', 'L'],
  CERAMIC_GROUPS: ['TC'],
};
